export default __webpack_public_path__ + "assets/favicons/favicon-alert-16x16.png";